import React from "react"

export const Cross = ({ classModifier = null, width = 14, height = 14, stroke = '#000000' }) => (
    <svg className="cross" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
            <path id="Vector" d="M1 1.0885L13 13.0885" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector_2" d="M1 13.0885L13 1.0885" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector_3" d="M1 1.0885L13 13.0885" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector_4" d="M1 13.0885L13 1.0885" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </svg>
)